import { cn } from '../../lib/utils';

interface Stat {
  label: string;
  value: React.ReactNode;
  sub?: string;
  color?: 'default' | 'green' | 'amber' | 'red' | 'blue' | 'violet';
}

interface SectionBannerProps {
  stats: Stat[];
  className?: string;
}

const COLOR_MAP = {
  default: 'text-foreground',
  green:   'text-emerald-600 dark:text-emerald-400',
  amber:   'text-amber-600 dark:text-amber-400',
  red:     'text-red-600 dark:text-red-400',
  blue:    'text-blue-600 dark:text-blue-400',
  violet:  'text-violet-600 dark:text-violet-400',
};

export function SectionBanner({ stats, className }: SectionBannerProps) {
  return (
    <div className={cn(
      'flex flex-wrap gap-4 px-4 py-3 border-b border-border bg-muted/30',
      className
    )}>
      {stats.map((stat, i) => (
        <div key={i} className="flex flex-col gap-0.5">
          <span className={cn('text-lg font-bold', COLOR_MAP[stat.color ?? 'default'])}>
            {stat.value}
          </span>
          <span className="text-xs text-muted-foreground">{stat.label}</span>
          {stat.sub && (
            <span className="text-[10px] text-muted-foreground">{stat.sub}</span>
          )}
        </div>
      ))}
    </div>
  );
}
